import React from 'react';
import { Icon } from '@chakra-ui/react';
import {
  MdBarChart,
  MdPerson,
  MdHome,
  MdOutlineShoppingCart,
  MdMic
} from 'react-icons/md';
import MainDashboard from 'views/admin/default';
import Usage from 'views/admin/usage';
import Profile from 'views/admin/profile';
import DataTables from 'views/admin/data';
import VoiceAIDemo from 'views/admin/createVoiceAi';

const routes = [
  {
    name: 'Create Widget',
    layout: '/admin',
    path: '/create-widget',
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: <MainDashboard />,
    protected: true,
  },
  {
    name: 'Data',
    layout: '/admin',
    icon: <Icon as={MdBarChart} width="20px" height="20px" color="inherit" />,
    path: '/data',
    component: <DataTables />,
    protected: true,
  },
  {
    name: 'Voice AI Demo',
    layout: '/admin',
    path: '/voice-ai',
    icon: <Icon as={MdMic} width="20px" height="20px" color="inherit" />,
    component: <VoiceAIDemo />,
    protected: true,
    hidden: true, // This will hide it from the sidebar
  },
  {
    name: 'Usage',
    layout: '/admin',
    path: '/usage',
    icon: (
      <Icon
        as={MdOutlineShoppingCart}
        width="20px"
        height="20px"
        color="inherit"
      />
    ),
    component: <Usage />,
    secondary: true,
    protected: true, 
  },
  {
    name: 'Profile',
    layout: '/admin',
    path: '/profile',
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: <Profile />,
    protected: true, 
  }
];

export default routes;